export default "__VITE_ASSET__626021a1__$_?nuxt_component=async&nuxt_component_name=SvgoMarkerPin05__"